<template>
  <div>
    <Button @click="exportWord">导出word</Button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wordData: {
        data: {},
        url: '',
        title: '',
        img: '',
        list: [],
      },
    };
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
  },
  methods: {
    init() {
      this.wordData = this.data;
      console.log("this.wordData",this.wordData)
    },
    // 导出word
    loadFile(exportUrl, callback) {
      PizZipUtils.getBinaryContent(exportUrl, callback);
    },

    base64DataURLToArrayBuffer(dataURL) {
      const base64Regex = /^data:image\/(png|jpg|svg|svg\+xml);base64,/;
      if (!base64Regex.test(dataURL)) {
        return false;
      }
      const stringBase64 = dataURL.replace(base64Regex, '');
      let binaryString;
      if (typeof window !== 'undefined') {
        binaryString = window.atob(stringBase64);
      } else {
        binaryString = new Buffer(stringBase64, 'base64').toString('binary');
      }
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes.buffer;
    },
    exportWord() {
      //   var ImageModule = require('open-docxtemplater-image-module');
      // 点击导出word
      let _this = this;
      // 读取并获得模板文件的二进制内容
      JSZipUtils.getBinaryContent(_this.wordData.url, function (error, content) {
        // exportTemplate.docx是模板。我们在导出的时候，会根据此模板来导出对应的数据
        // 抛出异常
        if (error) {
          throw error;
        }

        // 图片处理
        let opts = {};
        opts.centered = true; // 图片居中，在word模板中定义方式为{%%image}
        opts.fileType = 'docx';
        opts.getImage = function (chartId) {
          return _this.base64DataURLToArrayBuffer(chartId);
        };
        opts.getSize = function () {
          return [600, 300];
        };

        let imageModule = new ImageModule(opts);
        // 创建一个PizZip实例，内容为模板的内容
        // let zip = new PizZip(content);
        // 创建一个JSZip实例，内容为模板的内容
        let zip = new JSZip(content);

        // 创建并加载docxtemplater实例对象
        let doc = new docxtemplater();
        doc.attachModule(imageModule);
        doc.loadZip(zip);

        // 设置模板变量的值
        doc.setData({
          ..._this.wordData,
        });

        try {
          // 用模板变量的值替换所有模板变量
          doc.render();
        } catch (error) {
          // 抛出异常
          let e = {
            message: error.message,
            name: error.name,
            stack: error.stack,
            properties: error.properties,
          };
          throw error;
        }
        // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
        let out = doc.getZip().generate({
          type: 'blob',
          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });
        // 将目标文件对象保存为目标类型的文件，并命名
        saveAs(out, _this.wordData.title + '.docx');
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    //左侧点击选择的一栏变化后更新数据
    wordData(now) {
      this.init();
    },
  },
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/wordExport/wordExport.vue